import { render, staticRenderFns } from "./register-start.vue?vue&type=template&id=99067b60&"
import script from "./register-start.vue?vue&type=script&lang=js&"
export * from "./register-start.vue?vue&type=script&lang=js&"
import style0 from "./register-start.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports